// Proposal only. Verify the filled-cart provider in a theme copy before publishing.
(() => {
  const root = document.documentElement;
  const flag = 'nf-cart-overlays-hidden';
  const selector = '#CartDrawer #update-cart[role="dialog"]';
  let queued = false;

  function isOpen(cart) {
    if (!cart.isConnected || cart.getClientRects().length === 0) return false;
    for (let node = cart; node; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' || style.visibility === 'hidden' ||
          style.visibility === 'collapse') return false;
    }
    return true;
  }

  function sync() {
    queued = false;
    const open = [...document.querySelectorAll(selector)].some(isOpen);
    if (root.classList.contains(flag) !== open) root.classList.toggle(flag, open);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  function start() {
    new MutationObserver((records) => {
      // Ignore our own flag; late cart/widget insertion still triggers a check.
      if (records.some(r => r.target !== root || r.attributeName !== 'class')) schedule();
    }).observe(root, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
    addEventListener('resize', schedule);
    addEventListener('pageshow', schedule);
    document.addEventListener('transitionend', schedule, true);
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();

/* Keep Shopify's original consent handlers; clarify button labels only. */
(() => {
  function labelConsentButtons() {
    const labels = {
      'shopify-pc__banner__btn-accept': 'Godta alle',
      'shopify-pc__banner__btn-decline': 'Avslå',
      'shopify-pc__banner__btn-manage-prefs': 'Innstillinger'
    };
    for (const [id, label] of Object.entries(labels)) {
      const button = document.getElementById(id);
      if (button && button.textContent !== label) button.textContent = label;
    }
  }
  new MutationObserver(labelConsentButtons).observe(document.documentElement, {childList:true, subtree:true});
  labelConsentButtons();
})();

/* Keep the mobile chat launcher clear of product express payment. */
(() => {
  const init = () => {
    const payments = document.querySelectorAll('[id^="ProductInfo-"] .payment-button-container');
    if (!payments.length) return;
    const visible = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      document.documentElement.classList.toggle('nf-express-payment-visible', visible.size > 0);
    });
    payments.forEach(payment => observer.observe(payment));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Keep mobile product cards and quick-buy controls clear of the chat launcher. */
(() => {
  const init = () => {
    const cards = document.querySelectorAll(".card-product");
    if (!cards.length) return;
    const visible = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      document.documentElement.classList.toggle("nf-product-cards-visible", visible.size > 0);
    });
    cards.forEach(card => observer.observe(card));
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
